import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useEditAdminCookieMutation } from "@/redux/services/adminCookiesApi"
import { setToast } from "@/redux/toastSlice"
import type { EditAdminCookiePayload } from "@/types/entities/cookie"

export const useEditAdminCookie = () => {
  const dispatch = useAppDispatch()
  const [editAdminCookie, response] = useEditAdminCookieMutation()

  const handleEditAdminCookie = async ({
    body,
    id,
  }: {
    body: EditAdminCookiePayload
    id: string
  }) => {
    try {
      const response = await editAdminCookie({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success edit cookie",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { editAdminCookie: handleEditAdminCookie, response }
}
